import { render, staticRenderFns } from "./ProjectActionsRename.vue?vue&type=template&id=3b7d697c&lang=pug&"
import script from "./ProjectActionsRename.vue?vue&type=script&lang=js&"
export * from "./ProjectActionsRename.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActionsRename.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports